import { Modal } from 'almanac-ui/Modal'
import { Text } from 'blaze-ui/Text/Text'
import { ConfirmModal } from 'hooks/useConfirmModal'
import { pluralize } from 'utils'

interface Props extends ConfirmModal {
  platformName: string
  count: number
}

export const ConfirmDisconnectModal = ({ onCancel, onConfirm, onPressOutside, platformName, count }: Props) => (
  <Modal.Root onPressOutside={onPressOutside}>
    <Modal.Header title={`Remove ${platformName}`} />
    <Modal.Content>
      <Text>
        Are you sure you want to remove {platformName}? This will disconnect the {pluralize('account', count)} you have
        added.
      </Text>
    </Modal.Content>
    <Modal.Footer>
      <Modal.FooterContent slot="left">
        <Modal.FooterButton onPress={onCancel} size="lg" variant="tertiary">
          Cancel
        </Modal.FooterButton>
      </Modal.FooterContent>
      <Modal.FooterContent slot="right">
        <Modal.FooterButton onPress={onConfirm} size="lg" variant="primary">
          Remove
        </Modal.FooterButton>
      </Modal.FooterContent>
    </Modal.Footer>
  </Modal.Root>
)
